import { Box, Loader, Skeleton, Text } from "@mantine/core";
import React, { ReactNode } from "react";

interface OverlayProps {
    children: ReactNode;
    visible: boolean;
    overlayMessage?: string;
    skeletonRowCount?: number;
    skeletonColumnCount?: number;
}

function TableOverlay({ children, visible, skeletonRowCount = 5, skeletonColumnCount = 3 }: OverlayProps) {
    return (
        <Box style={{ position: 'relative' }}>
            {visible && (
                <Box
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 10,
                        pointerEvents: 'none', // allows clicks to pass through if needed
                    }}
                />
            )}

            {visible ? (
                <table style={{ width: '100%' }}>
                    <tbody>
                        {Array.from({ length: skeletonRowCount }).map((_, rowIdx) => (
                            <tr key={rowIdx}>
                                {Array.from({ length: skeletonColumnCount }).map((_, colIdx) => (
                                    <td key={colIdx} style={{ padding: '8px' }}>
                                        <Skeleton variant="rectangular" height={20} />
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                children
            )}
        </Box>
    );
}

function BlurOverlay({ visible, overlayMessage, children }: OverlayProps) {
    return (
        <Box style={{ position: 'relative' }}>
            {visible && (
                <Box
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backdropFilter: 'blur(2px)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                    }}
                >
                    <Loader size={28} />
                    {overlayMessage && (
                        <Text variant="body2" mt="sm" c="#333">
                            {overlayMessage}
                        </Text>
                    )}
                </Box>
            )}

            {children}
        </Box>
    );
}

export {
    TableOverlay,
    BlurOverlay
}